import { TimesIcon } from '@/icons';
import './index.scss';
interface BottomPanelProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  title: string;
  children: React.ReactNode;
}
const BottomPanel: React.FC<BottomPanelProps> = ({
  isOpen,
  setIsOpen,
  title,
  children,
}) => {
  return (
    <div
      className={`bottomPanel ${isOpen ? 'open' : ''}`}
      style={{ transform: 'translateY(100%)' }}
    >
      <div className="bottomPanel-header">
        <span>{title}</span>
        <button
          className="obro-transparent-btn"
          onClick={() => setIsOpen(false)}
        >
          <TimesIcon className={undefined} />
        </button>
      </div>
      <div className="bottomPanel-content">{children}</div>
    </div>
  );
};

export default BottomPanel;
